import { useQuery } from "@tanstack/react-query";
import { Link, NavLink } from "react-router-dom";
import { getMemberProfile } from "../lib/memberService";
import { listMyTeamCells } from "../lib/teamService";
import "../member-final.css";

export function TeamPage() {
  const profile = useQuery({ queryKey: ["profile"], queryFn: getMemberProfile });
  const cells = useQuery({ queryKey: ["my-team-cells"], queryFn: listMyTeamCells });
  const canManage = (profile.data?.level ?? 0) >= 7;

  return (
    <div className="member-app standalone-member-page">
      <header className="member-header">
        <Link className="member-logo" to="/app"><span>H</span><b>THE HOUSE</b></Link>
        <div className="member-header-actions"><NavLink to="/app" end>OFFERS</NavLink><NavLink to="/app/earnings">EARNINGS</NavLink></div>
      </header>
      <main>
        <section className="standalone-member-hero">
          <span>CELLS · OUTPUT · CONTROL</span>
          <h1>Manage verified output.<br />Not Discord noise.</h1>
          <p>Cell authority unlocks from platform performance. Overrides are tracked only from approved work and never from chat activity.</p>
        </section>

        {!canManage && (
          <section className="team-lock">
            <span>LEVEL 7 ACCESS</span>
            <h2>Earn Lead before managing people.</h2>
            <p>Keep completing tasks, protecting trust, and reviewing accurately. Management unlocks when the platform rank says you can run a cell.</p>
          </section>
        )}

        <section className="team-cell-stack">
          {(cells.data ?? []).map((cell) => (
            <article className="team-cell-panel" key={cell.id}>
              <div className="team-cell-head">
                <div>
                  <span>{cell.route.toUpperCase()} · L{cell.minimumManagerLevel}+ MANAGER</span>
                  <h2>{cell.name}</h2>
                  <p>Managed by {cell.managerHandle}. Invite slots: {cell.inviteSlots}.</p>
                </div>
                <strong>${cell.managerOverrideUsd.toFixed(2)}<small>verified override</small></strong>
              </div>
              <div className="team-stats">
                <div><span>MEMBERS</span><b>{cell.memberCount}</b></div>
                <div><span>ACTIVE</span><b>{cell.activeTasks}</b></div>
                <div><span>OVERDUE</span><b>{cell.overdueTasks}</b></div>
                <div><span>APPROVED</span><b>{cell.approvedTasks}</b></div>
                <div><span>OUTPUT</span><b>${cell.generatedUsd.toFixed(0)}</b></div>
              </div>
              <div className="team-member-table">
                <div className="team-member-row header"><span>Member</span><span>Rank</span><span>Trust</span><span>Active</span><span>Output</span></div>
                {cell.members.map((member) => (
                  <div className={member.overdueTasks > 0 ? "team-member-row warning" : "team-member-row"} key={member.id}>
                    <strong>{member.handle}<small>{member.route.toUpperCase()}</small></strong>
                    <span>L{member.level}</span>
                    <span>{member.trustScore}</span>
                    <span>{member.activeTasks}{member.overdueTasks > 0 && ` / ${member.overdueTasks} late`}</span>
                    <b>${member.generatedUsd.toFixed(0)}</b>
                  </div>
                ))}
              </div>
            </article>
          ))}
        </section>
      </main>
    </div>
  );
}
